'use client';

import { c as _c } from "react/compiler-runtime";
export function SharedMomentsSection() {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-rose-50/80 to-amber-50" />;
    t1 = <div className="absolute -top-20 -right-20 h-64 w-64 rounded-full bg-primary-100/40 blur-3xl" />;
    t2 = <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-rose-100/50 blur-2xl" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <section className="relative py-14 lg:py-16 overflow-hidden">{t0}{t1}{t2}<div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8"><div className="mx-auto max-w-3xl text-center"><p className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">The best products are the ones you try with other people. Sizzle is built around that — helping people have real, social experiences around food and drink, not just scroll past it.</p><p className="text-lg text-gray-600">Tastings with friends. Pop-ups at your local. Sampling days at the office. The kind of thing you actually remember.</p></div></div></section>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}